import { render, staticRenderFns } from "./config_advise.vue?vue&type=template&id=06f339f6&"
import script from "./config_advise.vue?vue&type=script&lang=js&"
export * from "./config_advise.vue?vue&type=script&lang=js&"
import style0 from "./config_advise.vue?vue&type=style&index=0&id=06f339f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports